export enum CertificatesDisplayType {
  All = 1,
  Personal = 2,
  Contract = 3,
  ContractUser = 4,
  User = 5,
}
